<template>
  <div class="box-detail">
    <div class="box-left">
      <div class="head-box">
        <div class="box-left-header" style="width: 100%">
          <div @click="$router.go(-1)" class="goBack c-position-static c-m-0">
            <i class="el-icon-arrow-left"></i>
            <span>售后工单</span>
            <i class="el-icon-document"></i>
          </div>
        </div>
      </div>
      <div class="box-left-content">
        <div>
          <c-form
            :formData="formData"
            :fields="extFields"
            :area="area"
            :options="options"
            :upload="upload"
            ref="form"
            @changeForm="osg.changeForm"
          >
            <template slot="phoneAfterSaleSA">
              <!-- 中间号 -->
              <el-popover
                v-if="privateNumber.show"
                placement="top-start"
                trigger="click"
                :content="privateNumber.phone"
              >
                <el-button
                  slot="reference"
                  class="c-w-1"
                  @click="osg.getPrivateNumber('9', null, formData._id, formData.exts.sid)"
                >
                  查看中间号
                </el-button>
              </el-popover>
              <el-input
                v-model="formData.exts.phoneAfterSaleSA"
                @blur="SAafterSalePhone"
                @input="formData.exts.sid = ''"
                :disabled="
                  extFields.some(
                    fiel =>
                      fiel.name == 'phone' &&
                      (fiel.operationType == '2'
                        ? true
                        : fiel.operationType == '3'
                        ? formData._id
                          ? true
                          : false
                        : false)
                  )
                "
                v-else
              ></el-input>
            </template>
            <template slot="sid">
              <el-select
                v-model="formData.exts.sid"
                placeholder="请选择工单"
                clearable
                @change="sidChange()"
              >
                <el-option
                  style="width:900px"
                  v-for="item in options['sid']"
                  :key="item._id"
                  :label="item.title"
                  :value="item._id"
                >
                  <template>
                    <p class="c-flex c-flex-between" style="overflow: auto;">
                      <span class="c-m-r-10" v-if="item.title">标题：{{ item.title }}</span>
                      <span class="c-m-r-10" v-if="item.title">姓名：{{ item.name }}</span>
                      <span class="c-m-r-10" v-if="item.title">手机号：{{ item.phone }}</span>
                      <span class="c-m-r-10" v-if="item.orderNum">编号：{{ item.orderNum }}</span>
                      <span class="c-m-r-10" v-if="item.status">
                        状态：{{ osg.codelabel('status', item.status) }}
                      </span>
                    </p>
                  </template>
                </el-option>
              </el-select>
            </template>
            <template slot="relatedPerson">
              <el-select
                ref="selectRelatedPerson"
                v-model="formData.exts.relatedPerson"
                placeholder="请选择关联人"
                clearable
                multiple
                @change="
                  () => {
                    if ($refs['selectRelatedPerson'] && $refs['selectRelatedPerson'][0]) {
                      $refs['selectRelatedPerson'][0].visible = false; //监听值发生变化就关闭它
                    } else if ($refs['selectRelatedPerson']) {
                      $refs['selectRelatedPerson'].visible = false;
                    }
                    $forceUpdate();
                  }
                "
              >
                <el-option
                  v-for="item in options['relatedPerson']"
                  :key="item._id"
                  :label="item.name"
                  :value="item._id"
                >
                  <template>
                    <p class="c-flex c-flex-between">
                      <span class="c-m-r-10">{{ item.name }}</span>
                      <span>{{ item.roleName }}</span>
                    </p>
                  </template>
                </el-option>
              </el-select>
            </template>
          </c-form>
        </div>
      </div>
      <div class="box-left-footer" v-has="'AfterSaleServiceAppointment,save'">
        <el-button type="primary" @click="doSave">提交</el-button>
        <el-button plain @click="getData">取消</el-button>
      </div>
    </div>
    <div class="c-flex c_flex_col c-w-1">
      <div class="box-detail" style="flex: 1">
        <div class="box-center">
          <el-tabs v-model="activeTab" @tab-click="tabClick" class="c-h-1 c-flex c-flex-col">
            <el-tab-pane label="业务动态" name="log">
              <div class="box-center-tool">
                <div>
                  <el-date-picker
                    v-model="log.searchDate"
                    type="datetimerange"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    :default-time="['00:00:00', '23:59:59']"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    clearable
                    @change="getLog"
                    class="search-date"
                  ></el-date-picker>
                </div>
                <div>
                  <el-input
                    placeholder="请输入标题/内容"
                    v-model="log.searchValue"
                    class="search-input"
                    clearable
                    @clear="getLog"
                    @keyup.enter.native="getLog"
                  >
                    <el-button slot="append" icon="el-icon-search" @click="getLog"></el-button>
                  </el-input>
                </div>
              </div>
              <div class="box-center-content">
                <div class="activity-card" v-for="(log, i) in log.fpi.data" :key="i">
                  <div class="activity-card-header">
                    <span class="c-font-500">
                      <i class="el-icon-monitor c-w-30"></i>
                      {{ log.title }}
                    </span>
                    <span>{{ log.createTime }}</span>
                  </div>
                  <div class="activity-card-content">
                    {{ log.content }}
                  </div>
                  <div class="activity-card-footer">
                    <span>操作人：{{ log.createUserName }}</span>
                  </div>
                </div>
              </div>
            </el-tab-pane>
            <el-tab-pane label="笔记" name="notes" v-if="false">
              <div class="box-center-tool">
                <div></div>
                <el-button
                  type="primary"
                  size="mini"
                  @click="
                    vqeditor.content = ``;
                    openNote = true;
                  "
                >
                  创建笔记
                </el-button>
              </div>
              <div class="box-center-content">
                <div class="activity-card" v-for="(note, i) in noteData" :key="i">
                  <div class="activity-card-header">
                    <span>
                      <i class="el-icon-edit-outline c-w-30"></i>
                      笔记
                    </span>
                    <span>{{ note.createTime }}</span>
                  </div>
                  <div
                    class="activity-card-content-node"
                    v-html="note.content"
                    v-if="!note.openNote"
                  ></div>
                  <c-editor
                    v-else
                    class="c-m-15"
                    :formData="note"
                    :value="'content'"
                    ref="editor"
                  ></c-editor>
                  <div class="activity-card-footer">
                    <span>操作人：{{ note.createUserName }}</span>
                  </div>
                </div>
              </div>
              <!-- markdown编辑器 -->
              <el-dialog
                title="笔记"
                :visible.sync="openNote"
                @close="vqeditor.content = ''"
                :close-on-click-modal="false"
                :close-on-press-escape="false"
              >
                <c-editor :formData="vqeditor" :value="'content'" ref="editor"></c-editor>
                <div slot="footer">
                  <el-button type="primary" @click="saveNote">确 认</el-button>
                  <el-button
                    @click="
                      openNote = false;
                      vqeditor.content = '';
                    "
                  >
                    取 消
                  </el-button>
                </div>
              </el-dialog>
            </el-tab-pane>
            <el-tab-pane label="通话记录" name="callRecords">
              <div class="box-center-tool">
                <div>
                  <el-date-picker
                    v-model="callRecords.searchDate"
                    type="datetimerange"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    :default-time="['00:00:00', '23:59:59']"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    clearable
                    @change="getCallRecords"
                    class="search-date"
                  ></el-date-picker>
                </div>
                <div>
                  <el-input
                    placeholder="请输入主叫/被叫号码"
                    v-model="callRecords.searchValue"
                    class="search-input"
                    clearable
                    @clear="getCallRecords"
                    @keyup.enter.native="getCallRecords"
                  >
                    <el-button
                      slot="append"
                      icon="el-icon-search"
                      @click="getCallRecords"
                    ></el-button>
                  </el-input>
                </div>
              </div>
              <div class="box-center-content">
                <div class="activity-card" v-for="(item, i) in callRecords.fpi.data" :key="i">
                  <div class="activity-card-header">
                    <span class="c-font-500">
                      <i class="el-icon-phone-outline c-w-30"></i>
                      <span v-if="item.callDirection == '0'">呼入</span>
                      <span v-else-if="item.callDirection == '1'">呼出</span>
                    </span>
                    <span>{{ formatCallResult(item.callResult) }}</span>
                  </div>
                  <div class="activity-card-content">
                    <div>
                      主叫：{{ item.callerName }}
                      {{ item.caller }}
                    </div>
                    <div>
                      被叫：{{
                        item.callWay == 4
                          ? item.calleeName || ''
                          : item.callDirection == '0'
                          ? item.calleeName || ''
                          : item.calleeName || formData.name || ''
                      }}{{ ' ' + item.callee }}
                    </div>
                    <div>
                      通话时间：{{ item.startTimeStr }} 至
                      {{ item.endTimeStr }}
                    </div>
                    <audio v-if="item.recordUrl" class="c-m-t-15" controls :src="item.recordUrl">
                      您的浏览器不支持 audio 标签。
                    </audio>
                  </div>
                  <div class="activity-card-footer">
                    <!-- <span>操作人：{{ item.createUserName }}</span> -->
                    <span></span>
                    <span>生成记录时间：{{ item.createTime }}</span>
                  </div>
                </div>
              </div>
            </el-tab-pane>
            <el-tab-pane label="操作记录" name="history">
              <div
                class="box-center-content"
                v-infinite-scroll="getHistory"
                :infinite-scroll-immediate="true"
              >
                <c-modify
                  :historyFpi="historyFpi"
                  :fields="extFields"
                  :fieldsObj="fieldsObj"
                  :options="options"
                  ref="modify"
                ></c-modify>
              </div>
            </el-tab-pane>
          </el-tabs>
        </div>
        <div class="box-right" :class="collapse ? 'box-collapse' : ''">
          <div class="box-right-header">
            <i class="el-icon-d-arrow-left" @click="collapse = false" v-if="collapse"></i>
            <i class="el-icon-d-arrow-right" @click="collapse = true" v-else></i>
          </div>
          <div class="box-right-content" v-show="!collapse">
            <el-collapse v-model="activeNames">
              <el-collapse-item name="1">
                <template slot="title">
                  <span>线索</span>
                  <!-- <el-button type="text" icon="el-icon-plus" @click.stop="newLead">
                    添加线索
                  </el-button> -->
                </template>
                <div class="card-group">
                  <div class="card-item" v-for="(item, i) of lead.relatedData" :key="i">
                    <div>
                      <i class="el-icon-s-custom card-item-logo" style="color: #606266"></i>
                    </div>
                    <div>
                      <p>
                        <el-link :href="'/lead/' + item._id" target="_blank">
                          {{ item.name }}
                        </el-link>
                      </p>
                      <p>
                        手机号：{{ item.phone }}
                        <!-- <el-link :href="'tel:' + item.phone"
                             target="_blank">
                      <i class="el-icon-phone-outline"></i>
                    </el-link> -->
                      </p>
                      <p>状态：{{ osg.formatCascade('LEADSTATUS', item.leadStatus) }}</p>
                      <p>留咨时间：{{ item.customTime }}</p>
                      <p>
                        省市区：{{
                          `${formatProvince(item.province)}${formatCity(item.city)}${formatDistrict(
                            item.district
                          )}`
                        }}
                      </p>
                      <p>信息渠道：{{ osg.formatCascade('channel', item.channel) }}</p>
                    </div>
                    <!-- <i class="el-icon-close card-item-icon-remove" @click="removeLead(item)"></i>
                    <i class="el-icon-edit card-item-icon-edit" @click="editLead(item)"></i> -->
                  </div>
                </div>
              </el-collapse-item>
              <el-collapse-item name="5">
                <template slot="title">
                  <span>工单</span>
                  <!-- <el-button type="text" icon="el-icon-plus" @click.stop="newServiceAppointment">
                添加工单
              </el-button> -->
                </template>
                <div class="card-group">
                  <div
                    class="card-item"
                    v-for="(item, i) of serviceAppointment.relatedData"
                    :key="i"
                  >
                    <div>
                      <i class="el-icon-tickets card-item-logo"></i>
                    </div>
                    <div>
                      <p>工单编号： {{ item.orderNum }}</p>
                      <p>
                        <el-link :href="'/serviceAppointment/' + item._id" target="_blank">
                          {{ item.title }}
                        </el-link>
                      </p>
                      <p>阶段：{{ osg.codelabel('stage', item.stage) }}</p>
                    </div>
                    <!-- <i
                  class="el-icon-close card-item-icon-remove"
                  @click="removeServiceAppointment(item)"
                ></i> -->
                    <i
                      class="el-icon-edit card-item-icon-edit"
                      @click="editServiceAppointment(item)"
                    ></i>
                  </div>
                </div>
              </el-collapse-item>
            </el-collapse>
          </div>
          <el-drawer
            custom-class="c-drawer"
            title="添加工单"
            :visible.sync="serviceAppointment.openRelate"
            direction="rtl"
            @close="initServiceAppointment"
            :wrapperClosable="false"
            :close-on-press-escape="false"
          >
            <div class="el-drawer__content">
              <el-tabs v-model="serviceAppointment.activeName" type="card">
                <el-tab-pane label="选择已有工单" name="search">
                  <p class="c-m-b-10 c-font-13">请输入工单标题/客户名称进行搜索</p>
                  <el-select
                    v-model="serviceAppointment.searchObj"
                    filterable
                    remote
                    reserve-keyword
                    placeholder
                    :remote-method="getServiceAppointmentData"
                    clearable
                    @clear="getServiceAppointmentData"
                    :loading="false"
                    @change="$forceUpdate()"
                    class="c-w-1"
                  >
                    <el-option
                      v-for="item in serviceAppointment.data"
                      :key="item._id"
                      :label="item.title"
                      :value="item"
                    >
                      <span class="c-fl">{{ item.title }}</span>
                      <span class="c-fr c-font-13">{{ item.name }}</span>
                    </el-option>
                  </el-select>
                </el-tab-pane>
                <el-tab-pane label="新建工单" name="create">
                  <el-form
                    :model="serviceAppointment.formData"
                    :rules="rules"
                    ref="serviceAppointmentFormData"
                    label-width="90px"
                    label-position="left"
                    hide-required-asterisk
                  >
                    <el-form-item label="客户姓名" prop="name">
                      <el-input v-model="serviceAppointment.formData.name"></el-input>
                    </el-form-item>
                    <el-form-item label="手机号" prop="phone">
                      <el-input v-model="serviceAppointment.formData.phone"></el-input>
                    </el-form-item>
                    <el-form-item
                      label="省市区"
                      prop="area"
                      :rules="{
                        required: true,
                        type: 'array',
                        trigger: 'blur',
                        message: '省市区不能为空'
                      }"
                    >
                      <el-cascader
                        popper-class="cascaderLabelHide-wrapper"
                        ref="areaSelectorSA"
                        :options="area.options"
                        :props="{
                          expandTrigger: 'hover'
                        }"
                        v-model="serviceAppointment.formData.area"
                        clearable
                      ></el-cascader>
                    </el-form-item>
                    <el-form-item label="详细地址" prop="address">
                      <el-input v-model="serviceAppointment.formData.address"></el-input>
                    </el-form-item>
                    <el-form-item label="工单标题" prop="title">
                      <el-input v-model="serviceAppointment.formData.title"></el-input>
                    </el-form-item>
                    <el-form-item label="优先级">
                      <el-radio-group
                        v-model="serviceAppointment.formData.priority"
                        @change="$forceUpdate()"
                      >
                        <el-radio
                          v-for="item of options.priority"
                          :key="item.value"
                          :label="Number(item.value)"
                        >
                          {{ item.label }}
                        </el-radio>
                      </el-radio-group>
                    </el-form-item>
                    <el-form-item label="预约时间" prop="applyTime">
                      <el-date-picker
                        v-model="serviceAppointment.formData.applyTime"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        type="datetime"
                        placeholder="选择日期时间"
                      ></el-date-picker>
                    </el-form-item>
                    <el-form-item label="备注" prop="describe">
                      <el-input
                        type="textarea"
                        :rows="2"
                        v-model="serviceAppointment.formData.describe"
                      ></el-input>
                    </el-form-item>
                    <el-form-item label="阶段">
                      <el-select v-model="serviceAppointment.formData.stage">
                        <el-option
                          v-for="item in options.stage"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item label="状态">
                      <el-select v-model="serviceAppointment.formData.status">
                        <el-option
                          v-for="item in options.status"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                          v-show="serviceAppointment.formData.stage == item.value.slice(0, -2)"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                  </el-form>
                </el-tab-pane>
              </el-tabs>
            </div>
            <div class="el-drawer__footer" v-if="serviceAppointment.activeName == 'search'">
              <el-button
                type="primary"
                :disabled="!serviceAppointment.searchObj._id"
                @click="
                  saveServiceAppointment('search');
                  initServiceAppointment();
                "
              >
                保存
              </el-button>
              <el-button plain @click="initServiceAppointment()">取消</el-button>
            </div>
            <div class="el-drawer__footer" v-if="serviceAppointment.activeName == 'create'">
              <el-button type="primary" @click="saveServiceAppointment()">保存</el-button>
              <el-button plain @click="initServiceAppointment">取消</el-button>
            </div>
          </el-drawer>
          <el-drawer
            custom-class="c-drawer"
            title="编辑工单"
            :visible.sync="serviceAppointment.openEdit"
            direction="rtl"
            @close="initServiceAppointment"
            :wrapperClosable="false"
            :close-on-press-escape="false"
          >
            <div class="el-drawer__content">
              <el-form
                :model="serviceAppointment.formData"
                :rules="rules"
                ref="serviceAppointmentFormData"
                label-width="90px"
                label-position="left"
                hide-required-asterisk:true
              >
                <el-form-item label="线索姓名" prop="name">
                  <el-input v-model="serviceAppointment.formData.name"></el-input>
                </el-form-item>
                <el-form-item label="手机号" prop="phone">
                  <el-input v-model="serviceAppointment.formData.phone"></el-input>
                </el-form-item>
                <el-form-item
                  label="省市区"
                  prop="area"
                  :rules="{
                    required: true,
                    type: 'array',
                    trigger: 'blur',
                    message: '省市区不能为空'
                  }"
                >
                  <el-cascader
                    :options="area.options"
                    :props="{
                      expandTrigger: 'hover'
                    }"
                    ref="areaSelectorSAF"
                    popper-class="cascaderLabelHide-wrapper"
                    v-model="serviceAppointment.formData.area"
                    clearable
                  ></el-cascader>
                </el-form-item>
                <el-form-item label="详细地址" prop="address">
                  <el-input v-model="serviceAppointment.formData.address"></el-input>
                </el-form-item>
                <el-form-item label="工单标题" prop="title">
                  <el-input v-model="serviceAppointment.formData.title"></el-input>
                </el-form-item>
                <!-- <el-form-item label="优先级">
              <el-radio-group
                v-model="serviceAppointment.formData.priority"
                @change="$forceUpdate()"
                class="c-flex"
              >
                <el-radio v-for="item of options.priority" :key="item.value" :label="item.value">
                  {{ item.label }}
                </el-radio>
              </el-radio-group> 
            </el-form-item>-->
                <el-form-item label="预约时间">
                  <el-date-picker
                    v-model="serviceAppointment.formData.applyTime"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    type="datetime"
                    placeholder="选择日期时间"
                  ></el-date-picker>
                </el-form-item>
                <el-form-item label="描述" prop="describe">
                  <el-input type="textarea" :rows="2" v-model="formData.describe"></el-input>
                </el-form-item>
                <el-form-item label="阶段">
                  <el-select
                    v-model="serviceAppointment.formData.stage"
                    :disabled="tenantId == '1340835581184723420'"
                  >
                    <el-option
                      v-for="item in options.stage"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="状态">
                  <el-select
                    v-model="serviceAppointment.formData.status"
                    :disabled="tenantId == '1340835581184723420'"
                  >
                    <el-option
                      v-for="item in options.status"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                      v-show="serviceAppointment.formData.stage == item.value.slice(0, -2)"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item
                  label="信息渠道"
                  v-if="tenantId != '4551453470943235290'"
                  :rules="{
                    required: true,
                    trigger: 'blur',
                    type: 'array',
                    message: '信息渠道不能为空'
                  }"
                >
                  <el-cascader
                    clearable
                    v-model="serviceAppointment.formData.channel"
                    :options="options.channel"
                    :props="{ label: 'name' }"
                  ></el-cascader>
                </el-form-item>
                <template v-for="(extField, idx) in SAextFields">
                  <el-form-item
                    v-if="
                      !extField.frontEndConfig.detailHide &&
                        !extField.frontEndConfig.leadDetailHide &&
                        (!extField.frontEndConfig.showField ||
                          (extField.frontEndConfig.showField &&
                            isShowField(
                              serviceAppointment.formData,
                              extField.name,
                              extField.frontEndConfig.showField,
                              extField.frontEndConfig.showValue
                            )))
                    "
                    :key="idx"
                    :label="extField.nameDisp"
                    :prop="`exts.${extField.name}`"
                    :rules="{
                      required: extField.required == '1',
                      trigger: 'blur',
                      message: extField.nameDisp + '不能为空'
                    }"
                    :class="
                      extField.frontEndConfig.readOnly
                        ? extField.frontEndConfig.creatable
                          ? formData._id
                            ? 'c-pointer-n'
                            : ''
                          : 'c-pointer-n'
                        : ''
                    "
                  >
                    <template
                      v-if="
                        extField.type == 'text' ||
                          extField.type == 'textarea' ||
                          extField.type == 'number' ||
                          extField.type == 'phone'
                      "
                    >
                      <el-input
                        v-model="serviceAppointment.formData.exts[extField.name]"
                        :type="extField.type"
                      ></el-input>
                    </template>
                    <template v-if="extField.type == 'radio'">
                      <el-radio-group
                        v-model.number="serviceAppointment.formData.exts[extField.name]"
                        class="c-flex"
                      >
                        <el-radio
                          v-for="item in options[extField.valueOption]"
                          :key="item.value"
                          :label="item.value"
                        >
                          {{ item.label }}
                        </el-radio>
                      </el-radio-group>
                    </template>
                    <template v-if="extField.type == 'checkbox'" @change="$forceUpdate()">
                      <el-checkbox-group
                        v-model="serviceAppointment.formData.exts[extField.name]"
                        @change="$forceUpdate()"
                      >
                        <el-checkbox
                          v-for="item in options[extField.valueOption]"
                          :label="item.value"
                          :key="item.value"
                        >
                          {{ item.label }}
                        </el-checkbox>
                      </el-checkbox-group>
                    </template>
                    <template v-if="extField.type == 'select'">
                      <el-select
                        v-model="serviceAppointment.formData.exts[extField.name]"
                        placeholder="请选择"
                        clearable
                        :disabled="
                          extField.frontEndConfig.readOnly
                            ? extField.frontEndConfig.creatable
                              ? formData._id
                                ? true
                                : false
                              : true
                            : false
                        "
                      >
                        <el-option
                          v-for="item in options[extField.valueOption]"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        ></el-option>
                      </el-select>
                    </template>
                    <template v-if="extField.type == 'cascade'">
                      <el-cascader
                        :popper-class="
                          extField.frontEndConfig.cascaderLabelHide
                            ? 'cascaderLabelHide-wrapper'
                            : ''
                        "
                        :ref="extField.valueOption + 'cascader'"
                        v-model="serviceAppointment.formData.exts[extField.name]"
                        :options="options[extField.valueOption]"
                        :props="{
                          multiple: extField.frontEndConfig.multiple ? true : false,
                          label: 'name',
                          expandTrigger: extField.frontEndConfig.propsExpandTrigger
                            ? extField.frontEndConfig.propsExpandTrigger
                            : 'click',
                          checkStrictly: extField.frontEndConfig.propsCheckStrictly
                            ? extField.frontEndConfig.propsCheckStrictly
                            : false
                        }"
                        clearable
                        @change="
                          if (extField.frontEndConfig.cascaderLabelHide) {
                            if (
                              $refs[extField.valueOption + 'cascader'] &&
                              $refs[extField.valueOption + 'cascader'][0]
                            ) {
                              $refs[extField.valueOption + 'cascader'][0].dropDownVisible = false; //监听值发生变化就关闭它
                            }
                          }
                          $forceUpdate();
                        "
                      ></el-cascader>
                    </template>
                    <template v-if="extField.type == 'file'">
                      <el-upload
                        :class="{
                          'c-upload-maxLimit':
                            serviceAppointment.formData.exts[extField.name] &&
                            serviceAppointment.formData.exts[extField.name].length >=
                              extField.frontEndConfig.max
                        }"
                        :action="upload.url"
                        :data="upload.data"
                        :file-list="serviceAppointment.formData.exts[extField.name]"
                        list-type="picture-card"
                        :limit="extField.frontEndConfig.max || 10"
                        :on-exceed="osg.uploadExceed"
                        :before-upload="
                          file => {
                            return osg.beforeUpload(
                              file,
                              extField.frontEndConfig.fileType,
                              'upload'
                            );
                          }
                        "
                        :on-success="
                          (response, file, fileList) => {
                            let returnData = osg.uploadSuccess(
                              response,
                              file,
                              fileList,
                              extField.name,
                              true
                            );
                            serviceAppointment.formData.exts[extField.name] = returnData;
                            return returnData;
                          }
                        "
                        :on-error="osg.uploadError"
                        :before-remove="
                          (file, fileList) => {
                            let returnData = osg.beforeRemove(
                              file,
                              fileList,
                              extField.name,
                              serviceAppointment.formData.exts[extField.name]
                            );
                            serviceAppointment.formData.exts[extField.name] = returnData;
                            return false;
                          }
                        "
                        :on-preview="osg.uploadPreview"
                      >
                        <i class="el-icon-plus"></i>
                        <div
                          slot="file"
                          slot-scope="{ file, fileList }"
                          v-if="extField.frontEndConfig.fileType == 'video'"
                          style="width: 100%; height: 100%"
                        >
                          <span class="el-upload-list__item-actions" style="z-index: 100">
                            <span
                              class="el-upload-list__item-preview"
                              @click="osg.uploadPreview(file)"
                            >
                              <i class="el-icon-video-play"></i>
                            </span>

                            <span
                              class="el-upload-list__item-delete"
                              @click="
                                serviceAppointment.formData.exts[extField.name] = osg.beforeRemove(
                                  file,
                                  fileList,
                                  extField.name,
                                  serviceAppointment.formData.exts[extField.name]
                                )
                              "
                            >
                              <i class="el-icon-delete"></i>
                            </span>
                          </span>

                          <video
                            style="width: 100%; height: 100%; object-fit: fill; border-radius: 0"
                            :src="file.url"
                            class="avatar"
                            controls="controls"
                          >
                            您的浏览器不支持视频播放
                          </video>
                        </div>
                      </el-upload>
                      <el-dialog
                        :modal="false"
                        custom-class="dialog-img"
                        :visible.sync="upload.dialogVisible"
                      >
                        <img width="100%" :src="upload.dialogImageUrl" alt />
                      </el-dialog>
                    </template>

                    <template v-if="extField.type == 'time'">
                      <el-time-select
                        v-model="serviceAppointment.formData.exts[extField.name]"
                        placeholder="选择时间"
                      ></el-time-select>
                    </template>
                    <template v-if="extField.type == 'date' || extField.type == 'datetime'">
                      <el-date-picker
                        v-model="serviceAppointment.formData.exts[extField.name]"
                        :type="extField.type"
                        :value-format="
                          extField.type == 'datetime' ? 'yyyy-MM-dd HH:mm:ss' : 'yyyy-MM-dd'
                        "
                        placeholder="选择日期"
                      ></el-date-picker>
                    </template>
                    <template v-if="extField.type == 'switch'">
                      <el-switch
                        v-model="serviceAppointment.formData.exts[extField.name]"
                        active-color="#13ce66"
                        inactive-color="#ff4949"
                        active-value="1"
                        inactive-value="0"
                      ></el-switch>
                    </template>
                    <template v-if="extField.type == 'rate'">
                      <el-rate
                        v-model.number="serviceAppointment.formData.exts[extField.name]"
                        @change="$forceUpdate()"
                      ></el-rate>
                    </template>
                  </el-form-item>
                </template>
              </el-form>
            </div>
            <div class="el-drawer__footer">
              <el-button type="primary" @click="saveServiceAppointment()">保存</el-button>
              <el-button plain @click="initServiceAppointment()">取消</el-button>
            </div>
          </el-drawer>
          <!--关联/添加线索-->
          <el-drawer
            custom-class="c-drawer"
            title="添加线索"
            :visible.sync="lead.openRelate"
            direction="rtl"
            :wrapperClosable="false"
            :close-on-press-escape="false"
          >
            <div class="el-drawer__content">
              <el-tabs v-model="lead.activeName" type="card">
                <!-- <el-tab-pane label="选择已有线索" name="search">
              <p class="c-m-b-10 c-font-13">请输入客户姓名/手机号进行搜索</p>
              <el-select
                v-model="formData.leadIds"
                filterable
                remote
                reserve-keyword
                placeholder
                :remote-method="getLead"
                clearable
                @clear="getLead"
                :loading="false"
                @change="$forceUpdate()"
                class="c-w-1"
              >
                <el-option
                  v-for="item in lead.data"
                  :key="item._id"
                  :label="item.name"
                  :value="item._id"
                >
                  <span class="c-fl">{{ item.name }}</span>
                  <span class="c-fr c-font-13">{{ item.phone }}</span>
                </el-option>
              </el-select>
            </el-tab-pane> -->
                <el-tab-pane label="新增线索" name="create">
                  <el-form
                    :model="lead.formData"
                    :rules="rules"
                    ref="leadFormData"
                    label-width="90px"
                    label-position="left"
                    hide-required-asterisk
                  >
                    <el-form-item label="姓名" prop="name">
                      <el-input v-model="lead.formData.name" suffix-icon="el-icon-user"></el-input>
                    </el-form-item>
                    <el-form-item label="手机号" prop="phone">
                      <el-input
                        v-model="lead.formData.phone"
                        suffix-icon="el-icon-mobile-phone"
                      ></el-input>
                    </el-form-item>
                    <el-form-item label="邮箱" prop="email">
                      <el-input
                        v-model="lead.formData.email"
                        suffix-icon="el-icon-message"
                      ></el-input>
                    </el-form-item>
                    <el-form-item label="地址" prop="address">
                      <el-input v-model="lead.formData.address"></el-input>
                    </el-form-item>
                    <!-- <el-form-item label="状态" prop="leadStatus">
                  <el-select v-model="lead.formData.leadStatus">
                    <el-option
                      v-for="item in options.leadStatus"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item> -->
                    <!-- <el-form-item label="阶段" prop="lifecycleStage">
                  <el-select v-model="lead.formData.lifecycleStage">
                    <el-option
                      v-for="item in options.lifecycleStage"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item> -->
                  </el-form>
                </el-tab-pane>
              </el-tabs>
            </div>
            <div class="el-drawer__footer" v-if="lead.activeName == 'search'">
              <el-button type="primary" @click="saveLead()">保存</el-button>
              <el-button plain @click="initLead">取消</el-button>
            </div>
            <div class="el-drawer__footer" v-if="lead.activeName == 'create'">
              <el-button type="primary" @click="saveLead()">保存</el-button>
              <el-button plain @click="initLead">取消</el-button>
            </div>
          </el-drawer>
          <!--编辑客户-->
          <el-drawer
            custom-class="c-drawer"
            title="编辑线索"
            :visible.sync="lead.openEdit"
            direction="rtl"
            :wrapperClosable="false"
            :close-on-press-escape="false"
          >
            <div class="el-drawer__content">
              <el-form
                :model="lead.formData"
                :rules="rules"
                ref="leadFormData"
                label-width="90px"
                label-position="left"
                hide-required-asterisk
              >
                <el-form-item label="姓名" prop="name">
                  <el-input v-model="lead.formData.name"></el-input>
                </el-form-item>
                <el-form-item label="手机号" prop="phone">
                  <el-input v-model="lead.formData.phone"></el-input>
                </el-form-item>
                <el-form-item label="邮箱" prop="email">
                  <el-input v-model="lead.formData.email"></el-input>
                </el-form-item>
                <el-form-item label="地址" prop="address">
                  <el-input v-model="lead.formData.address"></el-input>
                </el-form-item>
                <el-form-item label="状态" prop="leadStatus">
                  <el-select v-model="lead.formData.leadStatus">
                    <el-option
                      v-for="item in options.leadStatus"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="阶段" prop="lifecycleStage">
                  <el-select v-model="lead.formData.lifecycleStage">
                    <el-option
                      v-for="item in options.lifecycleStage"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-form>
            </div>
            <div class="el-drawer__footer">
              <el-button type="primary" @click="saveLead()">保存</el-button>
              <el-button plain @click="initLead()">取消</el-button>
            </div>
          </el-drawer>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// import areajs from '../../resources/js/area.js';
// import areaList from '../../resources/js/areaList.js';

export default {
  name: 'AfterSaleServiceAppointment',
  data() {
    return {
      id: null,
      collapse: false,
      formData: { exts: {} },
      extFields: [],
      SAextFields: [], //工单扩展字段s
      fieldsObj: {},
      extField: {}, //特殊字段类型 如rate值为number类型,checkbox值为数组不能为空
      options: {
        //客户
        codecfg_leadStatus: { codeId: 'LEADSTATUS' },
        codecfg_lifecycleStage: { codeId: 'LIFECYCLESTAGE' },
        codecfg_callResult: { codeId: 'callResult' },
        codecfg_middleCallResult: { codeId: 'middleCallResult' },
        //工单
        codecfg_priority: { codeId: 'PRIORITY' },
        codecfg_stage: { codeId: 'STAGE' },
        codecfg_status: { codeId: 'STATUS' },
        //线索
        cascadeCode_LEADSTATUS: { codeId: 'LEADSTATUS' },
        cascadeCode_channel: { codeId: 'channel' }
      },
      rules: this.$util.rules,
      activeTab: 'log',
      // 日志
      log: {
        fpi: {
          data: []
        },
        searchValue: '',
        searchDate: []
      },
      // 笔记
      noteData: [],
      openNote: false,
      vqeditor: this.$util.vqeditor,
      // 通话记录
      callRecords: {
        fpi: {
          data: []
        },
        searchValue: '',
        searchDate: []
      },
      // 操作记录
      historyFpi: {
        page: 1,
        rows: 0,
        data: [],
        busy: false
      },
      historyHide: [
        'serviceAppointIds',
        'leadIds',
        'companyIds',
        'contractId',
        'insurancePolicyId',
        'province',
        'city',
        'district'
      ],
      serviceAppointment: {
        relatedData: [],
        openRelate: false,
        openEdit: false,
        Date: [],
        formData: {},
        activeName: 'search',
        searchObj: {} //搜索选中要关联的工单对象
      },
      company: {
        relatedData: [],
        openRelate: false,
        openEdit: false,
        Date: [],
        formData: {},
        activeName: 'search'
      },
      address: {
        relatedData: [],
        openEdit: false,
        formData: {}
      },
      lead: {
        relatedData: [],
        openRelate: false,
        openEdit: false,
        Date: [],
        formData: {},
        activeName: 'create'
      },
      //地址级联
      area: {
        options: this.osg.areaList,
        props: {
          checkStrictly: true,
          expandTrigger: 'hover'
        }
      },
      activeNames: ['1', '2', '3', '4', '5'],
      // 跟进记录列表
      record: {
        fpi: {
          data: []
        },
        searchValue: '',
        searchDate: [],
        openRecord: false, // 跟进记录弹窗
        recordFormData: {}, //跟进记录表单-上
        SArecordFormData: { gpsPoint: {}, exts: {} }, //跟进记录表单-下（工单信息）
        callData: [], //跟进记录-通话记录
        openCallRecord: false //跟进记录-通话记录弹窗
      },
      upload: {
        url: 'http://up-z1.qiniup.com',
        downloadUrl: this.osg.downloadUrl,
        data: {},
        dialogImageUrl: '',
        dialogVisible: false
      },
      colName: '', //动态表名
      tenantId: '',
      //中间号
      privateNumber: {
        show: false,
        phone: ''
      }
    };
  },
  computed: {
    editor() {
      return this.$refs.myQuillEditor.quill;
    }
  },
  beforeDestroy() {
    this.editor = null;
    delete this.editor;
  },
  mounted() {
    window.$this = this;
    this.id = this.osg.param('id');
    let acount = JSON.parse(sessionStorage['loginAccount']);
    this.tenantId = acount.tenantId || '';
    this.colName = this.osg.paramObj().colName; //从地址栏获取动态表名
    // this.getFields();
    this.osg.getFields(this.colName, () => {
      this.getData(() => {
        // this.getContract();
        this.SAafterSalePhone();
        this.sidChange('init');
        this.$forceUpdate();
      });
    });

    // this.osg.ajax(
    //   'biz/extField/query.do',
    //   {
    //     colName: this.colName,
    //     _all: '1',
    //     'is:state|integer#and': 1,
    //     // 'nin:preset|array-integer#and': 1,
    //     sortField: 'order',
    //     sortOrder: 'asc'
    //   },
    //   res => {
    //     this.extFields = res.data;
    //     this.options = this.options || [];
    //     for (var item of res.data) {
    //       if (this.$util.isJson(item.frontEndConfig)) {
    //         item.frontEndConfig = JSON.parse(item.frontEndConfig);
    //       } else {
    //         item.frontEndConfig = {};
    //       }
    //       if (item.valueOption)
    //         this.options['codecfg_' + item.valueOption] = {
    //           codeId: item.valueOption
    //         };
    //       //级联
    //       if (item.type == 'cascade')
    //         this.options['cascadeCode_' + item.valueOption] = {
    //           codeId: item.valueOption
    //         };
    //     }
    //     this.osg.codeoption(() => {
    //       this.getData(() => {
    //         // this.getContract();
    //         this.SAafterSalePhone();
    //         this.sidChange('init');
    //         this.$forceUpdate();
    //       });
    //     });
    //   },
    //   { noload: true }
    // );
  },
  methods: {
    formatCallResult(val) {
      return this.osg.codelabel('callResult', val);
    },
    formatMiddleCallResult(val) {
      return this.osg.codelabel('middleCallResult', val);
    },
    //上传头像图片文件转base64
    getFileToBase64(file) {
      var that = this;
      const isJPG = file.raw.type === 'image/jpeg';
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isJPG) {
        this.osg.toast('上传头像图片只能是 JPG 格式！', 'error');
        return;
      }
      if (!isLt2M) {
        this.osg.toast('上传头像图片大小不能超过 2MB！', 'error');
        return;
      }
      this.$util.Base64.imgFile(file.raw).then(res => {
        if (res) {
          that.formData.avatar = res;
          that.$forceUpdate();
        } else {
          this.osg.toast('上传失败', 'error');
        }
      });
    },
    getData(callback) {
      if (!this.id) return;
      this.osg.ajax(
        'biz/workflowAlert/query.do',
        { 'is:type1Type|integer#and': 1, 'is:_id|string#and': this.id },
        res => {
          if (res.data && res.data[0]) {
            this.formData = res.data[0];

            // 无手机号返回查看中间号按钮
            if (!this.formData.exts.phoneAfterSaleSA) this.privateNumber.show = true;

            this.$util.renderExtField(this.extFields, this.formData);
            this.formData.state = String(this.formData.state);
            this.formData.exts = this.formData.exts || {};
            this.formData.exts.relatedPerson =
              this.formData.exts.relatedPerson && this.formData.exts.relatedPerson.split(',');
            console.log(this.formData);
            //获取关联的工单
            this.getServiceAppointmentData(null, this.formData.exts.sid, () => {
              this.tabClick({ name: this.activeTab });
            });
            //线索
            this.getLead(this.formData.exts.leadIdAfterSale);

            if (callback) callback();
          }
        }
      );
    },
    getServiceAppointmentData(query, id, callback) {
      var params = {
        page: 1,
        rows: 10,
        sortField: 'createTime',
        sortOrder: 'desc',
        'regex:name|string#or': query,
        'regex:title|string#or': query,
        'is:_id|string#and': id
      };
      this.osg.ajax(
        'basic/serviceAppointment/query.do',
        params,
        res => {
          res.data.map(item => {
            item.label = item.name;
            item.value = item._id;
          });
          if (id) {
            this.serviceAppointment.relatedData = res.data;
          } else {
            this.serviceAppointment.data = res.data;
          }
          if (callback) callback();
          this.$forceUpdate();
        },
        { noload: true }
      );
    },
    //根据输入的手机号请求工单
    SAafterSalePhone() {
      console.log(this.formData);
      if (this.formData.exts.phoneAfterSaleSA) {
        this.osg.ajax(
          'basic/serviceAppointment/query.do',
          {
            'regex:phone|string#and': this.formData.exts.phoneAfterSaleSA
          },
          res => {
            this.$set(this.options, 'sid', res.data);
          }
        );
      } else {
        this.$set(this.options, 'sid', []);
      }
    },
    //切换工单
    sidChange(init) {
      if (this.formData.exts.sid) {
        this.osg.ajax(
          'biz/workflowAlert/queryAboutHandleUsers.do',
          {
            sid: this.formData.exts.sid
          },
          res => {
            this.$set(this.options, 'relatedPerson', res.data);
            if (!init) this.formData.exts.relatedPerson = '';
          },
          {
            fail: () => {
              this.$set(this.options, 'relatedPerson', []);
              this.formData.exts.relatedPerson = '';
            }
          }
        );
      } else {
        this.$set(this.options, 'relatedPerson', []);
        if (!init) this.formData.exts.relatedPerson = '';
      }
      this.$forceUpdate();
    },
    doSave() {
      if (this.osg.validate()) {
        this.$util.saveExtField(this.extFields, this.formData);
        let extsData = this.$util.deepCopy(this.formData.exts);
        // //TODO:写死
        extsData.relatedPerson = Array.isArray(extsData.relatedPerson)
          ? extsData.relatedPerson.join(',')
          : '';
        //将选择的关联人冗余存储中文
        let handleData = [];
        this.options['relatedPerson'].forEach(item => {
          if (this.formData.exts.relatedPerson.indexOf(item._id) != -1) {
            handleData.push(item.name);
          }
        });
        if (handleData && handleData.length) extsData.handleUserNames = handleData.join('、');
        //拿到选中的工单对象
        let activeSA = this.options['sid'].filter(item => item._id == extsData.sid)[0];
        if (activeSA && activeSA.exts) {
          extsData.sTerritory = activeSA.exts.sTerritory; //工单片区
          extsData.orderNumSA = activeSA.orderNum; //工单编号
          extsData.leakagesite = JSON.stringify(activeSA.exts.leakagesite); //工单维修部位
          extsData.orgIdAfterSaleSA = activeSA.orgId; //工单服务商Id
          extsData.orgNameAfterSaleSA = activeSA.orgName; //工单服务商名称
          extsData.createTimeSA = activeSA.createTime; //工单创建时间
        }
        let params = {
          handlerIds: this.formData.exts.relatedPerson,
          type: '1',
          type1Type: '1',
          memo: this.formData.exts.describe,
          exts: extsData
        };
        params = Object.assign(this.formData, params);
        params.orgId = activeSA.orgId; //工单服务商Id
        console.log(params);
        // return;
        this.osg.ajax('biz/workflowAlert/addPostSalesService.do', params, () => {
          this.getData();
          this.osg.toast('保存成功！');
        });
      }
    },
    /**
     * 切换tab页
     */
    tabClick(tab) {
      switch (tab.name) {
        case 'log':
          this.getLog();
          break;
        case 'notes':
          this.getNote();
          break;
        case 'record':
          this.getRecord();
          break;
        case 'callRecords':
          this.getCallRecords();
          break;
        case 'history':
          this.getHistory();
          break;
        default:
          return;
      }
    },
    /**
     * 日志
     */
    getLog() {
      this.log.searchDate = this.log.searchDate || [];
      // let sidList = this.serviceAppointment.relatedData.map(item => item._id);
      // if (Array.isArray(sidList) && sidList.length) {
      this.osg.ajax(
        'tenantLog/query.do',
        {
          // sid: this.id,
          // sid: sidList,
          // 'in:sid|Array#and': sidList.join(','),
          //  smodule: 'contact',
          // smodule: 'serviceAppointment',

          sid: this.id,
          smodule: 'workflowAlert',
          _all: '1',
          'regex:title|string#or': this.log.searchValue,
          'regex:content|string#or': this.log.searchValue,
          'gte:createTime|datetime#and': this.log.searchDate[0],
          'lte:createTime|datetime#and': this.log.searchDate[1],
          sortField: 'createTime',
          sortOrder: 'desc'
        },
        res => {
          this.log.fpi = res;
        },
        { noload: true }
      );
      // }
    },
    /**
     * 笔记
     */
    getNote() {
      this.osg.ajax(
        'note/query.do',
        {
          sid: this.id,
          smodule: 'workflowAlert',
          sortField: 'createTime',
          sortOrder: 'desc'
        },
        res => {
          this.noteData = res || [];
        }
      );
    },
    saveNote() {
      var params = {
        //sid，smodul，content，id，isDelete(值Y) 保存传123,修改传1234,删除传12345
        sid: this.id,
        smodule: 'workflowAlert',
        content: this.vqeditor.content
      };
      this.osg.ajax('note/upsert.do', params, () => {
        this.osg.toast('保存成功！');
        this.openNote = false;
        this.getNote();
      });
    },
    noteMdShow(note) {
      note.openNote = true;
    },
    /**
     * 通话记录
     */
    getCallRecords() {
      this.callRecords.searchDate = this.callRecords.searchDate || [];
      if (!this.formData.exts.callIdAfterSale) return;
      this.osg.ajax(
        'basic/sobot/query.do',
        {
          'is:callid|string#and': this.formData.exts.callIdAfterSale,
          _all: '1',
          // 'regex:callerName|string#or': this.callRecords.searchValue,
          // 'regex:caller|string#or': this.callRecords.searchValue,
          // 'regex:callee|string#or': this.callRecords.searchValue,
          'gte:createTime|datetime#and': this.callRecords.searchDate[0],
          'lte:createTime|datetime#and': this.callRecords.searchDate[1]
          // sortField: 'createTime',
          // sortOrder: 'desc'
        },
        res => {
          // contactsId
          this.callRecords.fpi = res;
        },
        { noload: true }
      );
    },
    /**
     * 操作记录
     */
    getHistory() {
      // 其他getFields查询会更新掉表单的fieldsObj
      let fieldsObj = {};
      this.extFields.map(item => {
        if (item.showList && item.showList.indexOf('6') != -1) {
          item.label = item.nameDisp;
          item.value = item.name;
          fieldsObj[item.name] = item;
        }
      });
      this.fieldsObj = fieldsObj;
      this.osg.ajax(
        'biz/changeLog/query.do',
        {
          sid: this.id,
          page: this.historyFpi.page,
          rows: (this.historyFpi.rows += 10)
        },
        res => {
          if (res) {
            if (res.data.length > 0) {
              // 不需要展示变更的字段名
              res.data.filter(item => {
                item.modifyList = item.modifyList.filter(obj => {
                  return (
                    this.fieldsObj[obj.field] &&
                    this.fieldsObj[obj.field].showList.indexOf('6') != -1
                  );
                });
                return item.modifyList.length > 0;
              });
              this.historyFpi = res;
            }
          }
        },
        { noload: true }
      );
    },
    formatField(row, column, cellValue) {
      return this.osg.codelabel('fields', cellValue);
    },
    formatFieldValue(row, column, cellValue) {
      if (cellValue) {
        if (this.$util.isJson(cellValue)) {
          cellValue = JSON.parse(cellValue);
        }
      }
      let field = this.fieldsObj[row.field];
      if (field && field.valueOption) {
        if (field.type == 'cascade') {
          if (field.frontEndConfig.multiple) {
            return this.osg.formatCascadeMultiple(field.valueOption, cellValue);
          } else {
            return this.osg.formatCascade(field.valueOption, cellValue);
          }
        } else {
          return this.osg.codelabel(field.valueOption, cellValue);
        }
      } else if (row.field == 'area' || (field && field.type == 'area')) {
        return this.formatArea(cellValue);
      } else {
        return cellValue;
      }
    },
    initLead() {
      this.lead.searchObj = {};
      this.lead.openEdit = false;
      this.lead.openRelate = false;
      this.lead.formData = {};
      this.lead.activeName = 'create';
      this.$refs['leadFormData'].resetFields();
      this.getLead(this.id);
    },
    getLead(leadId) {
      if (!leadId) return;
      var params = {
        'is:_id|string#and': leadId,
        sortField: 'createTime',
        sortOrder: 'desc',
        _all: '1'
      };
      this.osg.ajax(
        'basic/lead/query.do',
        params,
        res => {
          if (leadId) {
            this.lead.relatedData = res.data;
            console.log(this.lead.relatedData);
          } else {
            this.lead.data = res.data;
            // if (this.lead && !this.lead.length) this.lead.relatedData = [];
          }
        },
        { noload: true }
      );
    },
    saveLead() {
      // //将的客户id保存到新创建的线索的contactsIds字段
      // this.lead.formData.contactsId = this.lead.formData.contactsId || [];
      this.lead.formData.contactsId = this.id;
      if (this.osg.validate('leadFormData')) {
        //存经纬度用.的key来存值
        if (this.lead.formData.gpsPoint) {
          this.$set(
            this.lead.formData,
            'gpsPoint.longitude',
            this.lead.formData.gpsPoint.longitude
          );
          this.$set(this.lead.formData, 'gpsPoint.latitude', this.lead.formData.gpsPoint.latitude);
          delete this.lead.formData.gpsPoint;
        }
        this.osg.ajax('basic/lead/upsert.do', this.lead.formData, () => {
          this.osg.toast('操作成功！');
          this.initLead();
        });
      }
    },
    initServiceAppointment() {
      this.serviceAppointment.searchObj = {};
      this.serviceAppointment.openEdit = false;
      this.serviceAppointment.openRelate = false;
      this.serviceAppointment.formData = {};
      this.serviceAppointment.activeName = 'search';
      this.$refs['serviceAppointmentFormData'].resetFields();
    },
    editServiceAppointment(item) {
      var area = [];
      if (item.province) {
        area[0] = item.province;
      }
      if (item.city) {
        area[1] = item.city;
      }
      if (item.district) {
        area[2] = item.district;
      }
      item.area = area;
      this.$util.renderExtField(this.SAextFields, item);
      this.serviceAppointment.formData = item;
      this.serviceAppointment.openEdit = true;
    },
    newLead() {
      this.lead.openRelate = true;
    },
    editAddress(item) {
      var area = [];
      if (item.province) {
        area[0] = item.province;
      }
      if (item.city) {
        area[1] = item.city;
      }
      if (item.district) {
        area[2] = item.district;
      }
      item.area = area;
      this.address.formData = item;
      this.address.openEdit = true;
    },
    editLead(item) {
      var area = [];
      if (item.province) {
        area[0] = item.province;
      }
      if (item.city) {
        area[1] = item.city;
      }
      if (item.district) {
        area[2] = item.district;
      }
      item.area = area;
      this.lead.formData = item;
      this.lead.openEdit = true;
    },
    //获取跟进记录
    getRecord() {
      var params = {
        _all: '1',
        sortField: 'createTime',
        sortOrder: 'desc',
        bizType: 'workflowAlert',
        bizId: this.id
      };
      this.osg.ajax(
        'followingUpNote/query.do',
        params,
        res => {
          if (res.data) {
            this.record.fpi = res;
          }
        },
        {
          noload: true
        }
      );
    },
    //查看通话记录
    viewCallRecord(callId) {
      this.osg.ajax(
        'basic/sobot/queryByCallId.do',
        {
          callId
        },
        res => {
          if (res.data) {
            this.record.callData = res.data;
            this.record.openCallRecord = true;
          }
        },
        { noload: true }
      );
    },
    saveServiceAppointment(type) {
      //搜索关联
      if (type == 'search') {
        this.serviceAppointment.searchObj.leadIds.push(this.id);
        var obj = this.serviceAppointment.searchObj;
        obj.area = obj.area || [];
        obj.province = obj.area[0] || '';
        obj.city = obj.area[1] || '';
        obj.district = obj.area[2] || '';
        this.osg.ajax('basic/serviceAppointment/upsert.do', { data: JSON.stringify(obj) }, () => {
          this.getData();
        });
        this.initServiceAppointment();
      } else {
        if (this.osg.validate('serviceAppointmentFormData')) {
          this.serviceAppointment.formData.leadIds = this.serviceAppointment.formData.leadIds || [];
          if (this.serviceAppointment.formData.leadIds.indexOf(this.id) == -1) {
            //新建 将新线索id保存到工单leadIds字段
            this.serviceAppointment.formData.leadIds.push(this.id);
          } // else即编辑
          obj = this.serviceAppointment.formData;
          obj.area = obj.area || [];
          if (obj.area.length > 0) {
            obj.province = obj.area[0] || '';
            if (obj.area.length > 1) {
              obj.city = obj.area[1] || '';
              if (obj.area.length > 2) {
                obj.district = obj.area[2] || '';
              }
            }
          }
          // 自定义字段转换值
          this.$util.saveFormatExtField(this.SAextFields, this.serviceAppointment.formData);
          this.osg.ajax(
            'basic/serviceAppointment/upsert.do',
            {
              data: JSON.stringify(this.serviceAppointment.formData)
            },
            () => {
              this.getData();
            }
          );
          this.initServiceAppointment();
        }
      }
    },
    //选择客户
    handleSelect(item) {
      let contactIds = this.record.SArecordFormData.contactIds || [];
      contactIds.push(item._id);
      this.$set(this.record.SArecordFormData, 'contactIds', contactIds);
      this.$set(this.record.SArecordFormData, 'phone', item.phone);
      this.$set(this.record.SArecordFormData, 'address', item.address);
    },
    //反显服务步骤省市区
    formatArea(arr) {
      if (!arr) return;
      let str = '';
      if (arr[0]) str += this.osg.areaObj.province_list[arr[0]];
      if (arr[1]) str += this.osg.areaObj.city_list[arr[1]];
      if (arr[2]) str += this.osg.areaObj.county_list[arr[2]];
      return str;
    },
    formatProvince(cellValue) {
      if (!cellValue) return '';
      return this.osg.areaObj.province_list[cellValue];
    },
    formatCity(cellValue) {
      if (!cellValue) return '';
      return this.osg.areaObj.city_list[cellValue];
    },
    formatDistrict(cellValue) {
      if (!cellValue) return '';
      return this.osg.areaObj.county_list[cellValue];
    }
  },
  watch: {
    'record.SArecordFormData'() {
      if (!this.record.SArecordFormData.gpsPoint) {
        this.record.SArecordFormData.gpsPoint = {};
      }
      if (!this.record.SArecordFormData.exts) {
        this.record.SArecordFormData.exts = {};
      }
    },

    //area 级联组件点击label就消失
    'formData.area'() {
      if (this.$refs.areaSelector) {
        this.$refs.areaSelector.dropDownVisible = false; //监听值发生变化就关闭它
      }
    },
    'serviceAppointment.formData.area'() {
      if (this.$refs.areaSelectorSA) {
        this.$refs.areaSelectorSAF.dropDownVisible = false; //监听值发生变化就关闭它
      }
    },
    'record.SArecordFormData.area'() {
      if (this.$refs.areaSelectorRSA) {
        this.$refs.areaSelectorRSA.dropDownVisible = false; //监听值发生变化就关闭它
      }
    }
  }
};
</script>
<style lang="scss" scoped>
/*个人信息*/
.box-left-header-contact {
  border-bottom: 1px solid #dfe3eb;
}
.profile-info {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.profile-info > * {
  margin: 10px auto;
}
.profile-info > span {
  margin: 0;
  font-weight: 400;
  font-size: 24px;
}
.profile-info ul {
  display: flex;
}
.profile-info ul li {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 0 5px;
}
.profile-info ul li span:last-child {
  margin-top: 8px;
  font-size: 12px;
}
/* 快捷按钮 */
.shortcuts button {
  background-color: #eaf0f6;
  border-color: #cbd6e2;
  color: #506e91;
}
.shortcuts button i {
  font-weight: bold;
}
</style>
